import { render, staticRenderFns } from "./OrgDashboard.vue?vue&type=template&id=4f3bd98e&scoped=true&"
import script from "./OrgDashboard.vue?vue&type=script&lang=js&"
export * from "./OrgDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OrgDashboard.vue?vue&type=style&index=0&id=4f3bd98e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3bd98e",
  null
  
)

export default component.exports